<template>
  <v-dialog
    :value="isDialogActive"
    persistent
  >
    <v-card
      class="pa-6"
      color="primary"
    >
      <v-card-text>
        <component :is="dialog.component" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      dialog: (state) => state.dialog.dialog,
    }),

    isDialogActive() {
      return this.dialog.type !== '';
    },
  },
};
</script>
